<template>
  <section class="residency__institutions">
    <v-container>
      <div class="institutions">
        <v-heading level="h3">Instituições Envolvidas</v-heading>
        <div class="institutions__grid">
          <v-card v-for="(institution, index) in [institutions.urc, institutions.vivalle]" :key="index"
            class="institution"
            tag="span"
            :level="2"
            @click="showInstitution(index)">
              <img :src="institution.logo">
            <!-- <span>veja os detalhes <i class="icon-triangle"></i></span> -->
          </v-card>
        </div>
        <p v-html="institutions.description"></p>
       <!-- <v-lightbox :active="Object.keys(currInstitution).length > 0" @close="currInstitution = {}">
          <img :src="currInstitution.logo">
          <v-heading level="h6">Treinamento prático em:</v-heading>
          <body-text>
            <ul>
              <li v-for="(training, index) in currInstitution.trainings" :key="index">
                {{training}}
              </li>
            </ul>
          </body-text>
          <p>{{currInstitution.address}}</p>
        </v-lightbox> -->
      </div>
    </v-container>
  </section>
</template>


<script>
import Card from '@/components/layout/Card.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Lightbox from '@/components/layout/Lightbox.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';
import Container from '@/components/layout/Container.vue';

export default {
  name: 'ResidencyInstitutions',
  components: {
    'v-heading': Heading,
    'v-card': Card,
    'v-lightbox': Lightbox,
    'body-text': BodyText,
    'v-container': Container,
  },
  props: {
    institutions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currInstitution: () => {},
    };
  },
  methods: {
    showInstitution(institution) {
      this.currInstitution = this.institutions[institution];
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.residency__institutions';
#{$component} {
  padding: $section-gutter 0;
  .institutions{
    max-width: 624px;
    margin: auto;
    > h3.heading  {
      color: $color-d;
      text-align: center;
    }
    &__grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      grid-gap: 0 $gutter-l;
      margin: auto;
      // institutions cards has no lightbox, bg and box shadow
      // so this override was added in case of a mind change
      .card {
        box-shadow: none;
        pointer-events: none;
      }
    }
    .institution {
      padding-bottom: $gutter-l;
      margin-bottom: $gutter-xxl;
      cursor: pointer;
      transition: transform $transition-duration $transition-timing-function,
        box-shadow $transition-duration $transition-timing-function;
      img {
        display: block;
        max-width: 100%;
        margin: 0 auto $gutter-xl;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: $font-size-l;
        color: $color-sys-e;
        i {
          margin-left: $gutter;
          font-size: inherit;
          transform: rotate(-90deg);
          color: $color-a;
          font-size: $font-size-xs;
        }
      }
      &:hover {
        transform: translateY(#{-$gutter});
        box-shadow: $box-shadow-xxl;
      }
      &:active {
        transform: translateY(#{-($gutter/2)});
        box-shadow: $box-shadow-xl;
      }
    }
    > p {
      margin: 0;
      color: $color-sys-e;
      font-size: $font-size-xl;
      line-height: $line-height-xl;
      text-align: center;
    }
    // .lightbox {
    //   text-align: left;
    //   img {
    //     display: block;
    //     margin: 0 auto $gutter-xl;
    //     max-width: 100%;
    //   }
    //   p {
    //     margin: 0 0 $gutter-xl;
    //     text-align: center;
    //     color: $color-sys-e;
    //     font-size: $font-size;
    //   }
    //   ul li {
    //     font-size: $font-size-l;
    //   }
    // }
  }
}
</style>
